<template lang='pug'>
  form.forms.refer.component.container( @submit.prevent='refer' )
    close-button( @click.native='$emit("close")' )

    section.heading
      h3 {{ $t('Refer a Friend') }}

    fieldset
      label {{ $t("Friend's Name") }}
      bf-input.basic
        input(type='text' v-model='referral.name' required)

    fieldset
      label {{ $t("Friend's Email") }}
      bf-input.basic
        input(type='email' v-model='referral.email' required)

    fieldset
      label {{ $t('Message') }}
      textarea(v-model='referral.message' required)

    fieldset.centered-text
      bf-button.wide(type='submit')
        template(v-slot:text) {{ text }}
</template>

<script>
  import { db } from '@/main'
  import CloseButton from '@/components/buttons/close'

  export default {
    name: 'forms.refer',

    components: {
      CloseButton
    },

    props: {
      merchant: { required: true },
      business: { required: true},
      account: { required: true },
    },

    data() {
      return {
        referral: {},
        text: this.$t('Send Invitation')
        // accounts: []
      }
    },

    // firestore() {
    //   return {
    //     accounts: db.collection( 'accounts ')
    //   }
    // },

    watch: {
      account( curr, prev ) {
        if ( curr.id ) this.referral.message = curr.latest.referral.message
      }
    },

    created() {
      if ( this.account.id && this.account.latest ) this.referral.message = this.account.latest.referral.message
    },

    methods: {
      async refer() {
        this.text = 'Submitting...'
        let accs = await db.collection( 'accounts' ).where( 'email', '==', this.referral.email ).get()
        let doc = {
          for: { ...this.merchant, ...{ biz: this.business } },
          by: this.account,
          to: this.referral,
          status: 'invited',
          type: 'recommendation'
        }
        if ( accs.empty ) {
          db.collection( 'accounts' ).doc( this.account.id ).update({
            ...this.account.latest,
            ...{ latest: { referral: this.referral } }
          })
  
          db.collection( 'referrals' ).add( doc ).then( doc => {
            this.text = 'Complete. Resetting in 5 secs'
            setTimeout( () => {
              this.referral = { message: this.referral.message }
              this.text='Send Invitation'
            }, 5000 )
          })
        }
        else {
          this.text = 'User Already Exists'
          let body = `${this.account.name || this.account.username} has referred you to ${this.business.name} at https://app.bluefaucet.com/m/${this.business.id}`
          db.collection('notifications').add({
            created: new Date(),
            type: 'ref',
            for: accs.docs[0].id,
            ref: doc,
            title: 'Merchant Referral',
            body: body
          })
          setTimeout( () => {
            this.text = 'Invitation Email Sent.  Resetting in 3 secs...'
            setTimeout( () => {
              this.referral = { message: this.referral.message }
              this.text='Send Invitation'
            }, 3000 )
          }, 2000 )
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  textarea
    border solid 1px rgba(0 0 0 0.1)
    border-radius 5px
    padding 8px
    margin-bottom 10px
    width 95%

  .forms.refer
    background white
    border-radius 9px
    width 320px

    section
      padding 16px 32px
      background rgba( 0 0 0 .1 )

    fieldset
      padding 16px 32px

    label
      display block
      font-weight bold
      // font-size 1em
      margin 4px
      margin-top 32px
      &:first-child 
        margin-top 0
    
    .close
      position absolute
      right -6px
      top -6px
      background white
    
</style>
